/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivDaControllerGetCustomersParamsGen,
  MrfiktivDaControllerGetFreeSlotParamsGen,
  MrfiktivDaControllerGetServiceEventParamsGen,
  MrfiktivDaControllerGetServiceEventsParamsGen,
  MrfiktivDaCreateWorkshopTaskDtoGen,
  MrfiktivDaCustomerViewModelGen,
  MrfiktivDaEventTypesViewModelGen,
  MrfiktivDaExportReportDtoGen,
  MrfiktivDaFreeSlotViewModelGen,
  MrfiktivDaResourcesViewModelGen,
  MrfiktivDAServiceEventDetailViewModelGen,
  MrfiktivDaSetupDtoGen,
  MrfiktivDaSetupViewModelGen,
  MrfiktivDaWebhookControllerGetByLicensePlateParamsGen,
  MrfiktivDaWebhookControllerGetParamsGen,
  MrfiktivDaWebhookViewModelGen,
  MrfiktivDaWorkshopServicesViewModelGen,
  MrfiktivDaWorkshopTasksViewModelGen,
  MrfiktivOperationIdViewModelGen,
  MrfiktivPageViewModelGen,
  MrfiktivWebhookRequestDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Da<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags da
   * @name DaWebhookControllerWebhook
   * @summary Receive a hook from the DA
   * @request POST:/partner/{partnerId}/da/hook/{apiKey}
   * @secure
   * @response `201` `boolean` Successfully queued
   */
  daWebhookControllerWebhook = (
    partnerId: string,
    apiKey: string,
    data: MrfiktivWebhookRequestDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<boolean, any>({
      path: `/partner/${partnerId}/da/hook/${apiKey}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaWebhookControllerGet
   * @summary Gets all webhooks from a given partner
   * @request GET:/partner/{partnerId}/da/hook
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivDaWebhookViewModelGen)[] })`
   */
  daWebhookControllerGet = (
    { partnerId, ...query }: MrfiktivDaWebhookControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivDaWebhookViewModelGen[] }, any>({
      path: `/partner/${partnerId}/da/hook`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaWebhookControllerFindOne
   * @summary Gets the last dossier from a given partner
   * @request GET:/partner/{partnerId}/da/hook/{id}
   * @secure
   * @response `200` `MrfiktivDaWebhookViewModelGen` Open dossier
   */
  daWebhookControllerFindOne = (partnerId: string, id: number, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaWebhookViewModelGen, any>({
      path: `/partner/${partnerId}/da/hook/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaWebhookControllerGetByLicensePlate
   * @summary Gets a open dossier from a given partner
   * @request GET:/partner/{partnerId}/da/hook/{licensePlate}/byLicensePlate
   * @secure
   * @response `200` `MrfiktivDaWebhookViewModelGen` Open dossier
   */
  daWebhookControllerGetByLicensePlate = (
    { partnerId, licensePlate, ...query }: MrfiktivDaWebhookControllerGetByLicensePlateParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDaWebhookViewModelGen, any>({
      path: `/partner/${partnerId}/da/hook/${licensePlate}/byLicensePlate`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetResources
   * @summary Get a list of resources for the digital autohaus
   * @request GET:/partner/{partnerId}/da/resources
   * @secure
   * @response `200` `MrfiktivDaResourcesViewModelGen` The available resources
   */
  daControllerGetResources = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaResourcesViewModelGen, any>({
      path: `/partner/${partnerId}/da/resources`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetEventTypes
   * @summary Get a list of event types for the digital autohaus
   * @request GET:/partner/{partnerId}/da/eventTypes
   * @secure
   * @response `200` `MrfiktivDaEventTypesViewModelGen` The available resources
   */
  daControllerGetEventTypes = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaEventTypesViewModelGen, any>({
      path: `/partner/${partnerId}/da/eventTypes`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetServiceEvents
   * @summary Get a list of service events for the digital autohaus
   * @request GET:/partner/{partnerId}/da/serviceEvents
   * @secure
   * @response `200` `(MrfiktivDAServiceEventDetailViewModelGen)[]` The available service events
   */
  daControllerGetServiceEvents = (
    { partnerId, ...query }: MrfiktivDaControllerGetServiceEventsParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDAServiceEventDetailViewModelGen[], any>({
      path: `/partner/${partnerId}/da/serviceEvents`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetCustomers
   * @summary Get a list of customers from the digital autohaus
   * @request GET:/partner/{partnerId}/da/customers
   * @secure
   * @response `200` `(MrfiktivDaCustomerViewModelGen)[]` The available service events
   */
  daControllerGetCustomers = (
    { partnerId, ...query }: MrfiktivDaControllerGetCustomersParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDaCustomerViewModelGen[], any>({
      path: `/partner/${partnerId}/da/customers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetWorkshopServices
   * @summary Get a list of workshop services for the digital autohaus
   * @request GET:/partner/{partnerId}/da/workshopServices
   * @secure
   * @response `200` `MrfiktivDaWorkshopServicesViewModelGen` The available services
   */
  daControllerGetWorkshopServices = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaWorkshopServicesViewModelGen, any>({
      path: `/partner/${partnerId}/da/workshopServices`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetWorkshopTasks
   * @summary Get a list of workshop tasks for the digital autohaus
   * @request GET:/partner/{partnerId}/da/workshopTasks
   * @secure
   * @response `200` `MrfiktivDaWorkshopTasksViewModelGen` The available tasks
   */
  daControllerGetWorkshopTasks = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaWorkshopTasksViewModelGen, any>({
      path: `/partner/${partnerId}/da/workshopTasks`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetFreeSlot
   * @summary Get free slot
   * @request GET:/partner/{partnerId}/da/freeSlot
   * @response `200` `MrfiktivDaFreeSlotViewModelGen` The free slot
   */
  daControllerGetFreeSlot = (
    { partnerId, ...query }: MrfiktivDaControllerGetFreeSlotParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDaFreeSlotViewModelGen, any>({
      path: `/partner/${partnerId}/da/freeSlot`,
      method: "GET",
      query: query,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerSetup
   * @summary Setup the DA configuration.
   * @request POST:/partner/{partnerId}/da
   * @secure
   * @response `201` `MrfiktivDaSetupViewModelGen` Setup is completed
   */
  daControllerSetup = (partnerId: string, data: MrfiktivDaSetupDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaSetupViewModelGen, any>({
      path: `/partner/${partnerId}/da`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerIsSetup
   * @summary Get Setup status  DA configuration.
   * @request GET:/partner/{partnerId}/da
   * @secure
   * @response `200` `MrfiktivDaSetupViewModelGen` Setup status
   */
  daControllerIsSetup = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivDaSetupViewModelGen, any>({
      path: `/partner/${partnerId}/da`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerCreateWorkshopTask
   * @summary Create a workshop Task
   * @request POST:/partner/{partnerId}/da/workshopTask
   * @secure
   * @response `201` `MrfiktivDaCreateWorkshopTaskDtoGen` Workshop task
   */
  daControllerCreateWorkshopTask = (
    partnerId: string,
    data: MrfiktivDaCreateWorkshopTaskDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDaCreateWorkshopTaskDtoGen, any>({
      path: `/partner/${partnerId}/da/workshopTask`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerExport
   * @summary Export a report to the DA
   * @request POST:/partner/{partnerId}/da/{reportId}
   * @secure
   * @response `201` `MrfiktivOperationIdViewModelGen` Successfully queued
   */
  daControllerExport = (
    partnerId: string,
    reportId: string,
    data: MrfiktivDaExportReportDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivOperationIdViewModelGen, any>({
      path: `/partner/${partnerId}/da/${reportId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerExportSignRequest
   * @summary Export a report to the DA
   * @request POST:/partner/{partnerId}/da/{tpsId}/sign-request/{signRequestId}/export/async
   * @secure
   * @response `201` `MrfiktivOperationIdViewModelGen` Successfully queued
   */
  daControllerExportSignRequest = (
    partnerId: string,
    tpsId: string,
    signRequestId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivOperationIdViewModelGen, any>({
      path: `/partner/${partnerId}/da/${tpsId}/sign-request/${signRequestId}/export/async`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags da
   * @name DaControllerGetServiceEvent
   * @summary Get the DA document for a serviceEventId
   * @request GET:/partner/{partnerId}/serviceEvent/{serviceEventId}
   * @secure
   * @response `200` `MrfiktivDAServiceEventDetailViewModelGen` Successfully retrieved
   */
  daControllerGetServiceEvent = (
    { partnerId, serviceEventId, ...query }: MrfiktivDaControllerGetServiceEventParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivDAServiceEventDetailViewModelGen, any>({
      path: `/partner/${partnerId}/serviceEvent/${serviceEventId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
